import { __assign } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import './styles.css';
var ScatterGraph = function (_a) {
    var data = _a.data, _b = _a.yMin, yMin = _b === void 0 ? 0 : _b, yMax = _a.yMax, _c = _a.xMin, xMin = _c === void 0 ? 0 : _c, xMax = _a.xMax, yInterval = _a.yInterval, xInterval = _a.xInterval, graphHeight = _a.graphHeight, axesColor = _a.axesColor, originAxisColor = _a.originAxisColor, renderYLabel = _a.renderYLabel, renderXLabel = _a.renderXLabel, scatterPointColor = _a.scatterPointColor;
    // states
    var _d = useState({ x: 0, y: 0, yPlot: 0, xPlot: 0 }), pos = _d[0], setPos = _d[1];
    var _e = useState(false), showVerticalLine = _e[0], setShowVerticalLine = _e[1];
    var _f = useState(0), graphWidth = _f[0], setGraphWidth = _f[1];
    // refs
    var parentNode = useRef(null);
    var yPointsRef = useRef(null);
    // useEffects
    useEffect(function () {
        var _a;
        window.onresize = function () {
            var _a;
            setGraphWidth((((_a = parentNode === null || parentNode === void 0 ? void 0 : parentNode.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) - 30);
        };
        setGraphWidth((((_a = parentNode === null || parentNode === void 0 ? void 0 : parentNode.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) - 30);
    }, [parentNode]);
    // consts
    var textHeight = 16;
    var graphHeightDiff = yMax - yMin;
    var graphWidthDiff = xMax - xMin;
    var yRatio = graphHeight / graphHeightDiff;
    var xRatio = graphWidth / graphWidthDiff;
    var yPoints = Array.from({ length: graphHeightDiff / yInterval + 1 }, function (_, index) { return index * yInterval + yMin; });
    var xPoints = Array.from({ length: graphWidthDiff / xInterval + 1 }, function (_, index) { return index * xInterval + xMin; });
    var getGraphCoordinate = function (point, ratio) { return point * ratio; };
    var formattedGraphPoints = data.map(function (point) { return (__assign(__assign({}, point), { yPlot: graphHeight - getGraphCoordinate(point.y, yRatio) + getGraphCoordinate(yMin, yRatio), xPlot: getGraphCoordinate(point.x, xRatio) - getGraphCoordinate(xMin, xRatio) })); });
    return (React.createElement("div", { style: { position: 'relative', display: 'flex' } },
        showVerticalLine && (React.createElement("div", { className: 'verticalLine', style: {
                top: pos.yPlot + 20,
                left: pos.xPlot + 40
            } },
            "x: ",
            pos.x,
            React.createElement("br", null),
            "y: ",
            pos.y)),
        React.createElement("div", { style: { paddingRight: 6 }, ref: yPointsRef }, yPoints.reverse().map(function (yLabel, index) { return (React.createElement("div", { key: index, className: 'yPoints', style: {
                top: index * getGraphCoordinate(yInterval, yRatio) - index * textHeight - 7
            } }, renderYLabel ? renderYLabel(yLabel) : yLabel)); })),
        React.createElement("div", { className: 'svgWrapper', id: 'graph-svg-wrapper', ref: parentNode },
            React.createElement("svg", { width: graphWidth, height: graphHeight, version: '1.1', viewBox: "0 0 ".concat(graphWidth, " ").concat(graphHeight) },
                yPoints.map(function (_, index) { return (React.createElement("line", { key: index, x1: '0', x2: graphWidth, y1: "".concat(index * getGraphCoordinate(yInterval, yRatio)), y2: "".concat(index * getGraphCoordinate(yInterval, yRatio)), strokeDasharray: 4, stroke: axesColor, strokeWidth: 1, style: { zIndex: 1 } })); }),
                showVerticalLine && (React.createElement("line", { x1: pos.xPlot, x2: pos.xPlot, y1: 0, y2: graphHeight, strokeDasharray: '4', stroke: axesColor, strokeWidth: 1, className: 'hoverVerticalLine' })),
                formattedGraphPoints.map(function (grapghPoint, index) { return (React.createElement("circle", { key: index, cx: grapghPoint.xPlot, cy: grapghPoint.yPlot, fill: scatterPointColor ? scatterPointColor(grapghPoint) : '#f00', className: 'dotHover', onMouseEnter: function () {
                        setPos(grapghPoint);
                        setShowVerticalLine(true);
                    }, onMouseLeave: function () {
                        setShowVerticalLine(false);
                    } })); }),
                React.createElement("line", { x1: 0, x2: graphWidth, y1: graphHeight, y2: graphHeight, stroke: originAxisColor, strokeWidth: 1 }),
                React.createElement("line", { x1: 0, x2: 0, y1: 0, y2: graphHeight, stroke: originAxisColor, strokeWidth: 1 })),
            React.createElement("div", { style: { paddingRight: 6, display: 'flex' } }, xPoints.map(function (text, index) { return (React.createElement("div", { key: index, className: 'xPoints', style: {
                    top: graphHeight + 5,
                    left: index * (graphWidth / (xPoints.length - 1)) - 10.5
                } }, renderXLabel ? renderXLabel(text) : text)); })))));
};
ScatterGraph.defaultProps = {
    graphHeight: 400,
    axesColor: '#9E9E9E',
    originAxisColor: '#9E9E9E'
};
export default ScatterGraph;
